import { useQuery } from "@tanstack/react-query";
import { fetch } from "@/src/lib/fetch";
import { Offer, OfferYacht, Customer, Broker, Feedback } from "../app/Offers/model";

export function useOfferData(offerId: String | undefined) {
  const { data: usersData, isLoading: isLoadingUsers } = useQuery({
    queryKey: ["usersData", offerId],
    queryFn: () => fetch<{ customer: Customer; broker: Broker }>(`/api/offers/${offerId}/users`).then((res) => res),
    enabled: !!offerId,
  });

  const { data: offerData, isLoading: isLoadingOffer } = useQuery({
    queryKey: ["offerData", offerId],
    queryFn: () => fetch<Offer>(`/api/offers/${offerId}`).then((res) => res),
    enabled: !!offerId,
  });

  const {
    data: yachtsData,
    isLoading: isLoadingYachts,
    isFetching,
  } = useQuery({
    queryKey: ["yachtsData", offerId],
    queryFn: () => fetch<{ yachts: OfferYacht[] }>(`/api/offers/${offerId}/yachts`).then((res) => res),
    enabled: !!offerId,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: feedbacksData, isLoading: isLoadingFeedbacks } = useQuery({
    queryKey: ["feedbacksData", offerId],
    queryFn: () => fetch<{ feedbacks: Feedback[] }>(`/api/offers/${offerId}/feedbacks`).then((res) => res),
    enabled: !!offerId,
  });

  const data = { ...offerData, ...usersData, ...yachtsData, ...feedbacksData };

  return {
    usersData: usersData,
    offerData: offerData,
    yachtsData: yachtsData ?? [],
    feedbacksData: feedbacksData ?? [],
    isLoadingUsers: isLoadingUsers,
    isLoadingYachts: isLoadingYachts,
    isLoadingFeedbacks: isLoadingFeedbacks,
    isLoadingOffer: isLoadingOffer,
    isLoading: isLoadingUsers || isLoadingYachts || isLoadingOffer || isLoadingFeedbacks || isFetching,
  };
}
